import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { WrapperComponent, SectionTitle } from './../../_imports';
import Ampla from './../../../assets/imgs/enterprise_logos/ampla.webp';
import Brahzan from './../../../assets/imgs/enterprise_logos/brahzan.webp';
import Lismotor from './../../../assets/imgs/enterprise_logos/lismotor.webp';
import Mano from './../../../assets/imgs/enterprise_logos/mano.webp';
import NoPonto from './../../../assets/imgs/enterprise_logos/no_ponto.webp';
import RealLima from './../../../assets/imgs/enterprise_logos/real_lima.webp';
import Sipal from './../../../assets/imgs/enterprise_logos/sipal.webp';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import './partners.css';

const Partners = ({ title = "ALGUNS DE NOSSOS PARCEIROS!" }) => {
    const partners = [
        Ampla,
        Brahzan,
        Lismotor,
        Mano,
        NoPonto,
        RealLima,
        Sipal,
    ];

    return (
        <div className="partners-section-wrapper">
            <WrapperComponent>
                <SectionTitle text={title} />
                <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={5}
                    slidesPerView={5}
                    loop={true}
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        320: {
                            slidesPerView: 2,
                            spaceBetween: 6,
                        },
                        480: {
                            slidesPerView: 3,
                            spaceBetween: 6,
                        },
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 6,
                        },
                        1024: {
                            slidesPerView: 5,
                            spaceBetween: 6,
                        },
                    }}
                    className="partners-swiper"
                >
                    {partners.map((logo, index) => (
                        <SwiperSlide key={index} className="partner-slide">
                            <img
                                src={logo}
                                alt="Logo de empresa parceira Tonalida"
                                className="partner-logo"
                                loading="lazy"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </WrapperComponent>
        </div>
    );
};


export default Partners;
